import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
} from "@progress/kendo-react-grid";
import { checkPriority, timeSince } from '../../utils/ellowutils';
import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import { getPositionsDetails } from './services'
import "./tablestyles.scss";
import PopOver from '../popover';
import classnames from "classnames";
import { Icon } from "@iconify/react";

const Positions = (props: any) => {

  const navigate = useNavigate()
  const [draftKey , setDraftKey] = useState<any>(props.draftKey)

  const checkPriorityColour = (data: any) => {
    let value = checkPriority(data)
    
    switch (value){
      case 'Hot':
        return 'Red'
      case 'Warm':
        return 'Yellow'
      case 'Cold':
        return 'Blue'
      default: 
        return 'Blue'
    }
   }

  const ViewButton = (props: GridCellProps) => {    
     
    return (
      <td>
      {draftKey !== undefined ? 
        <button onClick={() => editPosition(props.dataItem.jobId)} className="applyButton"> View</button> :
        <button onClick={(e: any) => navigate('../position-details', { state: { jobId: props.dataItem.jobId, positionName: props.dataItem.positionName, companyName: props.dataItem.company }})}
          className="applyButton">
            View
        </button> 
      }
    </td>
    );
  }

  const editPosition = (jobId: any) => { 
    getPositionsDetails(jobId).then(
      (response: any) => {    
        if (response && response.status === 1) {          
         navigate('/createPositions' , {state : {jobMetadata: response.data[0].job_metadata , jobId:response.data[0].job_id, jobStatus:response.data[0].job_status}}) 
        }
      }
    ) 
  }


  const profileCell = (props: GridCellProps) => {

    if (props.dataItem.profiles && props.dataItem.profiles.length > 1){
      return <td><div className="positionStstus"><PopOver title="Multiple Position" position="rightBottom">
        {props.dataItem.profiles.map((item:string, key:number) => {
         return ( 
          <div key={key} className="positionList">
          <span className="status warning" />
          {item}
          </div>
         )
        })
        }
        </PopOver></div></td>
      }
      else{
     return <td>{props.dataItem.profiles}</td>
    }
  }

  const priorityCell = (props: GridCellProps) => {
    
    let currentDate = new Date().getTime()
    let dateOfRegistration = props.dataItem.createdDate
    var diff =(currentDate -  dateOfRegistration) / 1000;
    diff /= (60 * 60);
    let diff2 = Math.abs(Math.round(diff));
    
    return (
      <td className="statusWrap">
          {diff2 <= 24 &&
            <span className="userStatus">New</span>
          }
          <div className={classnames(checkPriorityColour(props.dataItem.priority) + " statusMessage")}>{props.dataItem.priority && checkPriority(props.dataItem.priority)}</div>
     </td>
)
  }

  return (
      <div>
        <Grid
            data={props.data}           
        >
              <GridNoRecords>
                <div className="noData">
                  <Icon icon="mdi:smiley-neutral-outline" />
                  No data to display
                </div>
              </GridNoRecords>
              <Column field="priority" title="Priority" cell={priorityCell} width="80px" />
              <Column field="positionName" title="Position" />
              <Column field="company" title="Company" />
              <Column field="jobType" title="Job Type" />
              <Column field="experienceLevel" title="Experience" cell={experienceCell}/>
              <Column field="skills" title="Skills" />
              <Column field="openFor" title="Open For" cell={openForCell}/>
              <Column field="allocated_to" title="Allocated To" />
              <Column field="activePositionStatus" title="Active Positions" />
              <Column field="profiles" title="Profiles" cell={profileCell} />
              <Column cell={ViewButton}  width="70px" />

            

        </Grid>  
    </div>
  )
}

export default Positions

const experienceCell = (props: GridCellProps) => {
  return (
    <td>
      {(props &&  props.dataItem && props.dataItem.experienceLevel) ? props.dataItem.experienceLevel.min + '-' : 'Not Mentioned'}  {props && props.dataItem && props.dataItem.experienceLevel && props.dataItem.experienceLevel.max}
    </td>
  )
}

const openForCell = (props: GridCellProps) => {
  
  return <td>{timeSince(props.dataItem.createdDate)}</td>
};